import type { SaveFinalDecisionPayload } from './types';

export function transformReasonForDecision(value: string) {
  return value?.trim();
}

export function transformSubmittedValues({
  finalScreeningStatus,
  reasonForDecision,
}: SaveFinalDecisionPayload) {
  const isApproved = finalScreeningStatus === 'APPROVED';
  const transformedReasonForDecision = reasonForDecision
    ? transformReasonForDecision(reasonForDecision)
    : null;
  return {
    finalScreeningStatus,
    reasonForDecision:
      isApproved && transformedReasonForDecision?.length === 0
        ? null
        : transformedReasonForDecision,
  };
}
